module.exports = __webpack_public_path__ + "static/img/coupon-bg-bottom.50935d0.png";